import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { ProjectInputProps } from "@/types";
import { projectStore, useVModel } from "@/hooks";


/**
 * An input for projects.
 */
const __default__ = {
  name: "ProjectInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    excludeCurrentProject: { type: Boolean },
    multiple: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const model = useVModel(props, "modelValue");

const projects = computed(() =>
  props.excludeCurrentProject
    ? projectStore.unloadedProjects
    : projectStore.allProjects
);

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    filled: "",
    "use-chips": "",
    "map-options": "",
    "emit-value": "",
    multiple: _ctx.multiple,
    label: "My Projects",
    options: projects.value,
    "option-label": "name",
    "option-value": "projectId"
  }, null, 8, ["modelValue", "multiple", "options"]))
}
}

})